<template>
  <div class="form-container">
    <slot></slot>
  </div>
</template>
